export const MAX_HORIZONTAL_CARDS = 2

export const MAX_ITEMS_CAROUSEL = 4
